import React from 'react';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { motion } from 'framer-motion';
import { Link } from 'gatsby';

const SimilarBlogPosts = ({ data }) => {
  return (
    <Wrapper>
      <SectionTitle style={{ marginLeft: '0em' }}>Similar blog posts</SectionTitle>
      <BlogPosts>
        {data.map((blogPost, index) => {
          const { previewImage, title, summary, slug } = blogPost;
          return (
            <PreviewLink to={`/blog/${slug.current}`}>
              <BlogPostPreview
                key={index}
                variants={blogPostPreviewVariants}
                whileHover="hover"
                whileTap="tap"
                layout
              >
                <GatsbyImage image={getImage(previewImage.asset.gatsbyImageData)} alt={title} />
                <motion.h4 variants={blogPostPreviewVariants}>{title}</motion.h4>
                <p>{summary.replaceAll('<br aria-hidden="true" />', ' ')}</p>
                <SeeMore variants={blogPostPreviewVariants}>
                  Read more
                  <Seperator />
                </SeeMore>
              </BlogPostPreview>
            </PreviewLink>
          );
        })}
      </BlogPosts>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -3rem;
  margin-bottom: 6.5rem;
  @media only screen and (max-width: 48rem) {
    margin-top: 3rem;
    margin-bottom: 3.75rem;
  }
`;

const SectionTitle = styled.h3`
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: 0.0185em;
  margin: 1.85em auto 1em;
  text-transform: lowercase;
`;

const BlogPosts = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  @media only screen and (max-width: 30rem) {
    flex-direction: column;
    > a:first-of-type {
      margin-bottom: 2.75rem;
    }
  }
`;

export const BlogPostPreview = styled(motion.div)`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  width: 100%;
  .gatsby-image-wrapper {
    max-width: 340px;
  }
  p {
    font-size: 1.25rem;
    color: var(--ax-black);
    margin-bottom: 1rem;
  }
  h4 {
    color: var(--ax-gold);
    font-size: 2rem;
    font-weight: 900;
    margin: 2rem 0 1rem 0;
    line-height: 1.2;
  }
  @media only screen and (max-width: 48rem) {
    h4 {
      font-size: 1.25rem;
    }
  }
`;

export const PreviewLink = styled(Link)`
  color: ${({ highlighedCaseStudy }) => (highlighedCaseStudy ? '#fff' : 'var(--ax-black)')};
  height: auto;
  text-decoration: none;
  width: calc(100% - 5rem);
  margin-right: 5rem;
  &:last-child {
    margin-right: 0;
  }
  @media only screen and (max-width: 48rem) {
    width: calc(100% - 1rem);
    margin-right: 1rem;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const SeeMore = styled(motion.div)`
  display: flex;
  flex-direction: column;
  font-weight: 700;
  margin-top: auto;
  text-transform: uppercase;
  width: 100%;
`;

export const Seperator = styled.div`
  background-color: ${({ highlighedCaseStudy }) =>
    highlighedCaseStudy ? '#fff' : 'var(--ax-black)'};
  height: 0.063rem;
  margin: 0.2rem 0;
  transition: background-color 150ms ease-in-out;
  width: 50%;
`;

export const blogPostPreviewVariants = {
  hover: {
    cursor: 'pointer',
    scale: 1.02,
    transition: {
      type: 'tween',
      ease: 'easeInOut',
      duration: 0.3
    }
  }
};

export default SimilarBlogPosts;
